import {format} from 'date-fns';

import {EMPTY_VALUE as EMPTY} from '@consts/common';

import {LocalizedTitle, ViolationTypeDto} from './types';

export const localizeTitle = (title: LocalizedTitle | null | undefined, language: string) => {
    if (!title) return EMPTY;
    return title[language] ?? title.en ?? Object.values(title)[0] ?? EMPTY;
};

export const formatTaxPeriod = (year?: number | null, month?: number | null) => {
    if (!year || !month) return EMPTY;
    return format(new Date(year, month - 1, 1), 'MM.yyyy');
};

export const formatThreshold = (value?: number | string | null) => {
    if (value == null || value === '') return EMPTY;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

const accumulateCodes = (node: ViolationTypeDto, result: string[]) => {
    result.push(node.code);
    (node as ViolationTypeDto & {children?: ViolationTypeDto[]}).children?.forEach((child) =>
        accumulateCodes(child, result),
    );
};

export const createViolationTypeTree = (items: ViolationTypeDto[]) => {
    const nodes = items.map((item) => ({...item, children: [] as ViolationTypeDto[]}));

    nodes.forEach((node) => {
        const children = nodes
            .filter((item) => item.parent?.id === node.id)
            .sort((a, b) =>
                localizeTitle(a.title, 'en').localeCompare(localizeTitle(b.title, 'en')),
            );

        if (children.length) {
            node.children.push(...children);
        }
    });

    return nodes
        .filter((item) => !item.parent)
        .sort((a, b) => localizeTitle(a.title, 'en').localeCompare(localizeTitle(b.title, 'en')));
};

export const collectViolationTypeCodes = (
    selectedCodes: string[],
    tree: Array<ViolationTypeDto & {children?: ViolationTypeDto[]}>,
) => {
    const result: string[] = [];

    selectedCodes.forEach((code) => {
        const find = (
            nodes: Array<ViolationTypeDto & {children?: ViolationTypeDto[]}>,
        ): (ViolationTypeDto & {children?: ViolationTypeDto[]}) | null => {
            for (const node of nodes) {
                if (node.code === code) return node;
                const found = find(node.children ?? []);
                if (found) return found;
            }
            return null;
        };

        const node = find(tree);
        if (node) accumulateCodes(node, result);
    });

    return Array.from(new Set(result));
};
